import { defineAsyncComponent } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import LoadingSpinner from "@two-ui/components/LoadingSpinner.vue";

export function initRecipientRoutes() {
  return [
    {
      path: "/",
      redirect: "/recipient",
    },
    {
      path: "/recipient",
      name: "recipient",
      component: async () =>
        defineAsyncComponent({
          loader: () => import("./views/BasePage.vue"),
          loadingComponent: LoadingSpinner,
        }),
      children: subRoutesRecipient,
    },
  ];
}

export const subRoutesRecipient = [
  {
    path: "",
    name: "recipient-home",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/RecipientHome.vue"),
        loadingComponent: LoadingSpinner,
      }),
  },
];

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (from.meta.scrollTopOnLeave || to.meta.scrollTopOnEnter)
      return {
        top: 0,
        left: 0,
      };
    else if (savedPosition) return savedPosition;
  },
  routes: initRecipientRoutes(),
});

export default router;
